import { useDeviceInfoContext } from '@sravni/react-utils';
import DEVICE_TYPE from '../enums/DeviceType.js';

const useDevice = () => {
    const deviceInfo = useDeviceInfoContext();
    let device = DEVICE_TYPE.MOBILE;
    switch (true) {
        case deviceInfo.tablet:
            device = DEVICE_TYPE.TABLET;
            break;
        case deviceInfo.phone:
            device = DEVICE_TYPE.MOBILE;
            break;
        default:
            device = DEVICE_TYPE.DESKTOP;
    }
    return device;
};

export { useDevice };
//# sourceMappingURL=useDevice.js.map
